import AllToken from "./components/AllToken";

function Token() {
  return (
    <>
      <AllToken />
    </>
  );
}

export default Token;
